import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '最新快讯', href: '#updates' },
  { label: '专题合集', href: '#index' },
  { label: '视频爆料', href: '#media' },
  { label: '热门话题', href: '#topics' },
  { label: '焦点爆料', href: '#carousel' },
  { label: '深度揭秘', href: '#cards' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-300/50'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#hero');
            }}
            className="flex items-center gap-2.5 flex-shrink-0 cursor-pointer"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-fire-line text-foreground-50 text-lg md:text-xl"></i>
            </div>
            <div className="flex flex-col leading-tight">
              <span className="text-foreground-50 font-bold text-sm md:text-base whitespace-nowrap font-heading">
                每日大赛黑料
              </span>
              <span className="text-foreground-500 text-xs whitespace-nowrap hidden sm:block">
                全网赛事内幕第一站
              </span>
            </div>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-3 py-2 text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 rounded-md hover:bg-background-200 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              className="hidden md:flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-foreground-50 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
              onClick={() => handleNavClick('#contact')}
            >
              <i className="ri-mail-send-line"></i>
              <span>投稿爆料</span>
            </button>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-200 hover:bg-background-200 transition-colors cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-b border-background-300/50">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-3 py-2.5 text-sm text-foreground-300 hover:text-primary-400 transition-colors rounded-md hover:bg-background-200 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#contact');
              }}
              className="mt-2 px-3 py-2.5 text-sm text-center bg-primary-500 hover:bg-primary-600 text-foreground-50 rounded-md font-medium transition-colors cursor-pointer"
            >
              <i className="ri-mail-send-line mr-1.5"></i>投稿爆料
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}